import styled from 'styled-components';
import {colors, devices, fonts} from '../../utils/styled/_variables.styled';
import { InfiosButton } from "../Button/Button.style";

export const InfiosLearnMore = styled.section`
    position: relative;
    display: flex;
    flex-direction: column;
    width: 420px;
    right: 0;
    margin-left: auto;
    margin-top: 61px;
    padding: 40px;
    background-color: ${colors.limeGreen};
    border-radius: 15.614px;

    ${InfiosButton} {
        justify-content: flex-end;
        margin-left: 30px;
        border-radius: 32.992px;
        background: ${colors.bluegray};
        color: ${colors.white};
        font-family: ${fonts.AeonikMono};
        font-size: 11px !important;
        font-style: normal;
        font-weight: 400;
        line-height: 10.143px;
        text-transform: uppercase;
        letter-spacing: -0.22px;
        padding: 12px 23px;
        align-self: flex-end;
        text-align: center;

        svg {
          width: 8.251px;
          height: 8.251px;
          margin-left: 6px;

          path {
            fill: ${colors.white}
          }
        }

        &:hover {
            color: ${colors.bluegray};

            svg {
              transform: translate(0,0);
              path {
                fill: ${colors.bluegray}
              }
            }
        }
    }

    span,
    p {
        & + ${InfiosButton} {
            margin-top: 24px;
        }
    }

    span,
    p {
      color: ${colors.infiosGray};
      font-family: ${fonts.AeonikPro};
      font-style: normal;
      font-size: 19px;
      font-weight: 400;
      line-height: 26.4px;
      letter-spacing: -0.48px;
    }

    span {
      font-weight: 500;
      line-height: 110%;
      font-size: 24px;
    }

    @media ${devices.mobileAndTablet} {
        display: none;
    }
`;
